<template>
  <div class="el-col-24">
    <h5 class="warp-title">客服统计</h5>
    <div class="search">
      <div class="clearfix">
        <div class="search-type">
          <!-- <span class="search-title">工单ID</span> -->
          <el-input size="small" v-model.trim="customerName" placeholder="请输入客服账号/真实姓名"></el-input>
        </div>
        <div class="search-type">
          <el-radio-group @change="changeDate" v-model="specifiedTime" size="small">
            <el-radio-button :label="1">近30天</el-radio-button>
            <el-radio-button :label="2">近7天</el-radio-button>
            <el-radio-button :label="3">今天</el-radio-button>
          </el-radio-group>
        </div>
        <!-- <div class="search-type">
          <span class="search-title">是否满意</span>
          <el-select class="w100" v-model="areYouSatisfied" size="small" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="满意" :value="1"></el-option>
            <el-option label="不满意" :value="2"></el-option>
          </el-select>
        </div> -->
        <div class="search-type">
          <span class="search-title">统计时间</span>
          <el-date-picker
            @change="changeTime"
            v-model="time"
            size="small"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="dateShortCutOptions">
          </el-date-picker>
        </div>
        <div class="search-type" v-if="querybtn.custome_statistics_query === 1">
          <el-button size="small" type="primary" @click="search()" :loading="isSearchLoading">查询</el-button>
        </div>
        <div class="search-type" v-if="querybtn.custome_statistics_export === 1">
          <el-button size="small" @click="export1()" :loading="isExportLoading">导出</el-button>
        </div>
      </div>
    </div>
    <el-table
      :data="tableData"
      border
      align="center"
      style="width: 100%">
      <el-table-column
        label="客服账号"
        align="center">
        <template slot-scope="scope">{{ scope.row.nickName }}</template>
      </el-table-column>
      <el-table-column
        label="真实姓名"
        align="center">
        <template slot-scope="scope">
          {{ scope.row.realName }}
        </template>
      </el-table-column>
      <el-table-column
        label="接待人数"
        align="center">
        <template slot-scope="scope">
          {{scope.row.reception}}
        </template>
      </el-table-column>
      <el-table-column
        label="平均首次响应时间（秒）"
        align="center">
        <template slot-scope="scope">
          {{scope.row.avgCorrespondTime}}
        </template>
      </el-table-column>
      <el-table-column
        label="平均会话响应时长（分）"
        align="center">
        <template slot-scope="scope">
          {{scope.row.avgSessionTime}}
        </template>
      </el-table-column>
      <el-table-column
        label="累计在线时长（小时）"
        align="center">
        <template slot-scope="scope">
          {{scope.row.correspondTime}}
        </template>
      </el-table-column>
      <el-table-column
        label="累计挂起时长（分）"
        align="center">
        <template slot-scope="scope">
          {{scope.row.pendDuration}}
        </template>
      </el-table-column>
      <el-table-column
        label="转单量"
        align="center">
        <template slot-scope="scope">
          {{scope.row.turnOrders}}
        </template>
      </el-table-column>
      <el-table-column
        label="提单量"
        align="center">
        <template slot-scope="scope">
          {{scope.row.submitOrder}}
        </template>
      </el-table-column>
      <el-table-column
        label="满意"
        align="center">
        <template slot-scope="scope">
          <el-link :underline="false" type="primary" v-if="scope.row.satisfaction > 0" @click="toSatisfaction(scope.row.nickName, 1)">
            {{scope.row.satisfaction}}
          </el-link>
          <span v-else>{{scope.row.satisfaction}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="不满意"
        align="center">
        <template slot-scope="scope">
          <el-link :underline="false" type="primary" v-if="scope.row.noSatisfaction > 0" @click="toSatisfaction(scope.row.nickName, 2)">
            {{scope.row.noSatisfaction}}
          </el-link>
          <span v-else>
            {{scope.row.noSatisfaction}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="120">
        <template slot-scope="scope">
          <span class="blue cursor" @click="openRecord(scope.row.id)" v-if="querybtn.custome_statistics_record === 1">查看聊天记录</span>
          <!-- <span class="blue cursor" @click="initRecord(scope.row)" v-if="querybtn.custome_statistics_record === 1">查看聊天记录</span> -->
          <router-link :to="{name: 'WorkDetail', params:{id: scope.row.id}, query: {num: scope.row.nickName, name: scope.row.realName, time: specifiedTime, day: time}}">
            <span class="blue">查看详情</span>
          </router-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt20"
      @size-change="handleSizeChange"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      align="right"
      background>
    </el-pagination>
    <el-dialog
      title="聊天记录查询"
      :visible.sync="showRecord"
      :close-on-click-modal="false"
      width="60%" top="3vh">
      <div class="chat-search">
        <el-input size="small" v-model.trim="searchForm.body" placeholder="关键字/用户手机号"></el-input>
        <el-date-picker
          v-model="recordTime"
          size="small"
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="false"
          :picker-options="dateShortCutOptions">
        </el-date-picker>
        <el-button size="small" type="primary" @click="onSearchRecordList" :loading="isSearch">查询</el-button>
      </div>
      <MessageList :list="recordData" :currentUserId="searchForm.customerUserId" />
      <div v-if="recordData.length===0" class="no-record">暂无聊天记录</div>
      <el-pagination
        @size-change="sizeChange2"
        @current-change="currentChange2"
        :current-page="searchForm.currentPage"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        class="mt20"
        align="right"
        background>
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import dateShortCutOptions from '../../utils/dateShortCutOptions'
import formatDateByTimestamp from '../../utils/formatDateByTimestamp'
import {iMCustomerStatistics, exportCustomerStatisticsList, queryChatHistoryRecord} from '../../api/statistics/index'
import { queryButtonPermission } from '../../api/public/auth'
export default {
  name: 'Service',
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign)
    let data = {
      id: global.$sider
    }
    queryButtonPermission(data).then((info) => {
      if (info.data.resultCode === 0) {
        this.querybtn = info.data.resultData
      } else {
        this.$message.error(info.data.resultMessage)
      }
    })
  },
  watch: {
    recordTime () {
      if (this.recordTime && this.recordTime.length > 0) {
        this.searchForm.startTime = this.recordTime[0]
        this.searchForm.endTime = this.recordTime[1]
      }
    }
  },
  data () {
    return {
      dateShortCutOptions: dateShortCutOptions,
      // areYouSatisfied: '',
      isSearch: false,
      isExportLoading: false,
      isSearchLoading: false,
      querybtn: {},
      id: '',
      loading: '',
      time: [],
      customerName: '',
      specifiedTime: 3,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      dialogVisible: false,
      showRecord: false,
      searchForm: {
        body: '',
        startTime: '',
        endTime: '',
        positiveDate: Date.now(),
        customerUserId: '',
        currentPage: 1,
        pageSize: 100
      },
      totalCount: 0,
      recordData: [],
      recordTime: []
    }
  },
  methods: {
    // 初始化聊天记录筛选的时间（默认一年范围）
    initChatRecordTime () {
      if (this.time && this.time.length > 0) {
        this.recordTime = [...this.time]
      } else {
        // 天数跨度
        let dayStep = this.specifiedTime === 1 ? 30 : this.specifiedTime === 2 ? 7 : 0
        let start = formatDateByTimestamp(Date.now() - (1000 * 60 * 60 * 24 * dayStep))
        let end = formatDateByTimestamp(Date.now())
        this.recordTime = [start, end]
      }
    },
    toSatisfaction (nickName, areYouSatisfied) {
      let specifiedTime = this.specifiedTime
      let startTime = ''
      let endTime = ''
      if (this.time && this.time.length > 0) {
        startTime = this.time[0]
        endTime = this.time[1]
      }
      this.$router.push({
        name: 'SatisfactionDetails',
        query: {
          areYouSatisfied: areYouSatisfied,
          specifiedTime: specifiedTime,
          startTime: startTime,
          endTime: endTime,
          nickName: nickName
        }
      })
    },
    // // 预览文件消息
    // toDownloadFile (item) {
    //   let url = item.fileUrl
    //   if (item.msgBody[0].msgContent[0].fileName.indexOf('.pdf') >= 0) {
    //     // pdf文件
    //     window.open(url)
    //   } else {
    //     // 非pdf文件
    //     window.open(
    //       'https://view.officeapps.live.com/op/view.aspx?src=' + url,
    //       '_blank'
    //     )
    //   }
    // },
    // openImg (url) {
    //   window.open(url)
    // },
    // scrollBottom () {
    //   if (this.$refs.recordContent) {
    //     this.$refs.recordContent.scrollTop = this.$refs.recordContent.scrollHeight - 520
    //   }
    // },
    // 查询历史记录
    onSearchRecordList () {
      this.searchForm.currentPage = 1
      this.initRecordList()
    },
    // 打开历史记录弹框
    openRecord (id) {
      this.searchForm.body = ''
      this.searchForm.customerUserId = id
      this.searchForm.currentPage = 1
      this.searchForm.pageSize = 100
      // this.initChatRecordTime()
      this.showRecord = true
      this.initRecordList()
    },
    // 初始化历史记录数据
    initRecordList () {
      this.isSearch = true
      queryChatHistoryRecord(this.searchForm).then(res => {
        if (res.data.resultCode === 0) {
          this.recordData = res.data.resultData
          this.totalCount = res.data.totalCount
        } else {
          this.$message.error(res.data.resultMessage)
        }
      }).catch(() => {
        this.$message.error('出错了~')
      }).finally(() => {
        this.isSearch = false
      })
    },
    currentChange2 (current) {
      this.searchForm.currentPage = current
      this.initRecordList()
    },
    sizeChange2 (size) {
      this.searchForm.pageSize = size
      this.searchForm.currentPage = 1
      this.initRecordList()
    },
    clear () {
      this.recordTime = []
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
      this.searchForm.body = ''
      this.initRecordList()
    },
    initdata () {
      let startTime = ''
      let endTime = ''
      if (this.time && this.time.length > 0) {
        startTime = this.time[0]
        endTime = this.time[1]
      }
      let data = {
        customerName: this.customerName,
        specifiedTime: this.specifiedTime,
        startTime: startTime,
        endTime: endTime,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      this.isSearchLoading = true
      iMCustomerStatistics(data).then(info => {
        this.initChatRecordTime()
        this.isSearchLoading = false
        let data = info.data
        if (info.data.resultCode === 0) {
          this.total = data.totalCount
          this.tableData = data.resultData
          let pageNum = Math.ceil(info.data.totalCount / this.pageSize)
          if (pageNum !== 0 && this.currentPage > pageNum) {
            this.currentPage = pageNum
            this.initdata()
          }
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isSearchLoading = false
      })
    },
    currentChange (val) {
      this.currentPage = val
      this.initdata()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.initdata()
    },
    search () {
      this.initdata()
    },
    export1 () {
      let startTime = ''
      let endTime = ''
      if (this.time) {
        startTime = this.time[0]
        endTime = this.time[1]
      }
      let data = {
        customerName: this.customerName,
        specifiedTime: this.specifiedTime,
        startTime: startTime,
        endTime: endTime
      }
      this.isExportLoading = true
      exportCustomerStatisticsList(data).then(info => {
        this.isExportLoading = false
        if (info.data.resultCode === 0) {
          let Url = info.data.resultData.fileDownLoadUrl
          window.open(Url)
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isExportLoading = false
      })
    },
    changeTime () {
      if (!this.time) {
        this.specifiedTime = 3
      } else {
        this.specifiedTime = ''
      }
    },
    changeDate () {
      this.time = []
    }
  },
  mounted () {
  }
}
</script>
<style lang="less" scoped>
// .pagination{
//   text-align: center;
// }
.search-box{
  overflow: hidden;
}
.no-record{
  text-align: center;
  margin-top: 40px;
  color: #999;
}
.search{
  a{
    line-height: 32px;
  }
}
.el-tabs{
  margin-top: 20px;
}
.el-button + .el-button{
  margin-left: 0;
}
.chat-search{
  display: table;
  margin-bottom: 20px;
  .el-input{
    width: 150px;
    margin-right: 10px;
    float: left;
  }
  .el-date-editor{
    width: 250px;
    float: left;
    margin-right: 10px;
  }
  .el-button{
    float: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Statistics/Service.vue